const GetEnumData = (enums, propertyLabel) => {
	return enums[propertyLabel];
}

export default GetEnumData;